import { Customer, CustomerOrder, CustomerSetting } from '../../entities';
import CustomerOrderRevision from '../../entities/customer-order-revision';
import { type OrderStatus } from '../../types';
import { LocalDate } from '../../utils/local-date';

/**
 * A row of the customer orders list, as returned by the customer order controller
 */
export interface CustomerOrderListItemDto {
  id: number;
  orderDate: string;
  status: OrderStatus;
  latestRevisionId: number | null;
  siteNames: string | null;
  siteNamesWithDisplayNumber: string | null;
  createdBy: string;
  createdDate: string;
  createdByCellPhone: string | null;
  canUpdate: boolean;
  canCancel: boolean;
  customer: {
    id: number;
    name: string;
    customerSetting: {
      dueDaysToPlaceOrders: number;
      dueTimeToPlaceOrders: string;
      dueDaysToCancelOrders: number;
      dueTimeToCancelOrders: string;
    } | null;
  } | null;
  revisions: Array<{ id: number; revisionNumber: number; createdBy: string; createdDate: string }>;
}

/**
 * Maps a customer orders list row to a CustomerOrder shaped like the ones loaded through the JSON:API, so that it can
 * be passed to the components which still use the JSON:API (order view, clone modal)
 */
// TODO: Update this funtion to use one CustomerOrder structure after migrating from JSON:API
export const toCustomerOrder = (item: CustomerOrderListItemDto): CustomerOrder =>
  Object.assign(new CustomerOrder(), {
    id: String(item.id),
    orderDate: new LocalDate(item.orderDate),
    status: item.status,
    latestRevisionId: item.latestRevisionId != null ? String(item.latestRevisionId) : undefined,
    siteNames: item.siteNames ?? undefined,
    siteNamesWithDisplayNumber: item.siteNamesWithDisplayNumber ?? undefined,
    customer: Object.assign(new Customer(), {
      id: item.customer ? String(item.customer.id) : undefined,
      name: item.customer?.name,
      customerSetting: Object.assign(new CustomerSetting(), item.customer?.customerSetting ?? {}),
    }),
    customerOrderRevisions: item.revisions.map((revision) =>
      Object.assign(new CustomerOrderRevision(), {
        id: String(revision.id),
        revisionNumber: revision.revisionNumber,
        meta: { createdBy: revision.createdBy, createdDate: revision.createdDate },
      })
    ),
    meta: {
      createdBy: item.createdBy,
      createdDate: item.createdDate,
      createdByCellPhone: item.createdByCellPhone ?? undefined,
      canUpdate: item.canUpdate,
      canCancel: item.canCancel,
    },
  });
